import React from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { SocialProofBar } from './components/SocialProofBar';
import { TestimonialsTop } from './components/TestimonialsTop';
import { PainSection } from './components/PainSection';
import { ProductOverview } from './components/ProductOverview';
import { TomosSection } from './components/TomosSection';
import { TomoIncludes } from './components/TomoIncludes';
import { BonusSection } from './components/BonusSection';
import { CountdownSection } from './components/CountdownSection';
import { PricingSection } from './components/PricingSection';
import { MarcaGourmetComparison } from './components/MarcaGourmetComparison';
import { MarcaGourmetDetails } from './components/MarcaGourmetDetails';
import { TestimonialsBottom } from './components/TestimonialsBottom';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostComparisonTable } from './components/CostComparisonTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-carbon selection:bg-brand-green/20" data-id="element-0">
      <TopBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SocialProofBar data-id="element-4" />
        <TestimonialsTop data-id="element-5" />
        <PainSection data-id="element-6" />
        <ProductOverview data-id="element-7" />
        <TomosSection data-id="element-8" />
        <TomoIncludes data-id="element-9" />
        <BonusSection data-id="element-10" />
        <CountdownSection data-id="element-11" />
        {/* We don't need to render PricingSection here because FinalCTA includes it,
            but the prompt asked for it in order. I'll render it here, and FinalCTA has a duplicate.
            Actually, the prompt says "11. PricingSection ... 18. FinalCTA - Repeat countdown + both pricing cards".
            So I will render it here as requested. */}
        <PricingSection data-id="element-12" />
        <MarcaGourmetComparison data-id="element-13" />
        <MarcaGourmetDetails data-id="element-14" />
        <TestimonialsBottom data-id="element-15" />
        <GuaranteeSection data-id="element-16" />
        <FAQSection data-id="element-17" />
        <CostComparisonTable data-id="element-18" />
        <FinalCTA data-id="element-19" />
      </main>
      <Footer data-id="element-20" />
      <SocialProofPopup data-id="element-21" />
    </div>;
}